import react from "react";


const INITIALSTATE = {
  isLoggedIn: null,
	Name: null,
	error : null
}

const AuthReducer = (state = INITIALSTATE, action) => {
	switch (action.type)
	{
	  case "SIGN_IN":
			return { ...state, isLoggedIn: true, session: action.session };
	     case "SIGN_OUT" :
			return { ...state, isLoggedIn: false, Name : null };
		 case "invalid_grant" :
			return { ...state, isLoggedIn: false, error: action.error.message};
			 default: return state;   
		
	};
}

export default AuthReducer;